/**
 * Utilitários para informações dinâmicas do sistema
 * Baseado no tipo de comissão (CIPA ou CIPAMIN ou CIPATR)
 */

import { getComissaoVisualInfo } from './cipaminUtils';

/**
 * Retorna o nome do sistema baseado no tipo de comissão
 * @param cnae - Código CNAE da empresa
 * @param tipoComissaoBanco - Tipo de comissão do banco (prioridade)
 * @param nomeEmpresa - Nome da empresa (opcional, usado como fallback)
 * @returns Nome do sistema (CIPA FÁCIL ou CIPAMIN FÁCIL ou CIPATR FÁCIL)
 */
export const getNomeSistema = async (
  cnae: string | null | undefined,
  tipoComissaoBanco?: string | null,
  nomeEmpresa?: string | null
): Promise<string> => {
  const info = await getComissaoVisualInfo(cnae, tipoComissaoBanco, nomeEmpresa);
  return `${info.tipo} FÁCIL`;
};

/**
 * Retorna a descrição completa do sistema baseado no tipo de comissão
 * @param cnae - Código CNAE da empresa
 * @param tipoComissaoBanco - Tipo de comissão do banco (prioridade)
 * @param nomeEmpresa - Nome da empresa (opcional, usado como fallback)
 * @returns Descrição do sistema
 */
export const getDescricaoSistema = async (
  cnae: string | null | undefined,
  tipoComissaoBanco?: string | null,
  nomeEmpresa?: string | null
): Promise<string> => {
  const info = await getComissaoVisualInfo(cnae, tipoComissaoBanco, nomeEmpresa);
  return `Sistema Completo de Gestão ${info.tipo} - 100% Conforme ${info.norma}`;
};

/**
 * Retorna a descrição curta do sistema baseado no tipo de comissão
 * @param cnae - Código CNAE da empresa
 * @param tipoComissaoBanco - Tipo de comissão do banco (prioridade)
 * @param nomeEmpresa - Nome da empresa (opcional, usado como fallback)
 * @returns Descrição curta
 */
export const getDescricaoCurtaSistema = async (
  cnae: string | null | undefined,
  tipoComissaoBanco?: string | null,
  nomeEmpresa?: string | null
): Promise<string> => {
  const info = await getComissaoVisualInfo(cnae, tipoComissaoBanco, nomeEmpresa);
  return `Sistema 100% Conforme ${info.norma} Vigente`;
};

/**
 * Retorna informações completas do sistema
 * @param cnae - Código CNAE da empresa
 * @param tipoComissaoBanco - Tipo de comissão do banco (prioridade)
 * @param nomeEmpresa - Nome da empresa (opcional, usado como fallback)
 * @returns Objeto com todas as informações do sistema
 */
export const getSistemaInfo = async (
  cnae: string | null | undefined,
  tipoComissaoBanco?: string | null,
  nomeEmpresa?: string | null
) => {
  const info = await getComissaoVisualInfo(cnae, tipoComissaoBanco, nomeEmpresa);
  return {
    nome: `${info.tipo} FÁCIL`,
    nomeCompleto: `${info.tipo} FÁCIL EHS`,
    descricao: `Sistema Completo de Gestão ${info.tipo} - 100% Conforme ${info.norma}`,
    descricaoCurta: `Sistema 100% Conforme ${info.norma} Vigente`,
    tipo: info.tipo,
    norma: info.norma
  };
};

